import { LOCALE_COOKIE, normalizeLocale, type Locale } from "@/shared/i18n";

export function readLocaleCookie(): Locale | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${LOCALE_COOKIE}=([^;]*)`));
  if (!match) return null;
  try {
    return normalizeLocale(decodeURIComponent(match[1]));
  } catch {
    return null;
  }
}
